import React from 'react'
import PropTypes from 'prop-types'
import Grid from '@material-ui/core/Grid'

const Page = ({ children, style, ...props }) => (
  <Grid
    style={{ padding: '20px 0 40px', ...style }}
    spacing={24}
    justify="center"
    alignItems="center"
    {...props}
    container
  >
    {children}
  </Grid>
)

Page.Section = (props) => <Grid {...props} item />

Page.propTypes = {
  children: PropTypes.any.isRequired,
  style: PropTypes.object,
}

export default Page



// WEBPACK FOOTER //
// ./src/components/Page.js